export default {"src":"/_next/static/media/whole-yard.07e5418e.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};